import { _registerEnvironmentSkyboxShaderPatch } from '../material/pbr/environment-skybox-shader-composer.js';
import { registerEnvSceneUniforms, _invalidateSceneUboCaches } from './scene-ubo-extras.js';

const loadRotationSkyboxPatch = () => import('../material/pbr/fragments/environment-rotation-fragment.js');
function setEnvironmentRotation(scene, rotation) {
  registerEnvSceneUniforms(scene);
  scene._environmentRotation = rotation;
  _registerEnvironmentSkyboxShaderPatch(scene, 0, loadRotationSkyboxPatch);
  _invalidateSceneUboCaches(scene);
}

export { setEnvironmentRotation };
//# sourceMappingURL=set-environment-rotation.js.map
